import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api, fmtDate, formatError } from "@/lib/api";
import { PageHeader, Card, StatusBadge } from "@/pages/AppLayout";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export const TICKET_LABEL = { abierto: "Abierto", en_proceso: "En proceso", resuelto: "Resuelto" };

export default function Support() {
  const [form, setForm] = useState({ subject: "", message: "" });
  const [tickets, setTickets] = useState([]);
  const load = useCallback(() => api.get("/support/tickets").then((r) => setTickets(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const send = async () => {
    try { await api.post("/support/tickets", form); setForm({ subject: "", message: "" }); toast.success("Solicitud enviada al equipo de soporte"); load(); }
    catch (e) { toast.error(formatError(e)); }
  };

  return (
    <div data-testid="support-page">
      <PageHeader eyebrow="Ayuda" title="Soporte" subtitle="Envía tu consulta. El equipo la responde desde el panel de administración y verás la respuesta aquí." />
      <div className="grid lg:grid-cols-[1fr_1.2fr] gap-6">
        <Card className="space-y-4 h-fit">
          <h2 className="text-lg font-medium text-white">Nueva solicitud</h2>
          <Input placeholder="Asunto" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="support-subject-input" className="bg-[#0A0D14]" />
          <Textarea placeholder="Describe tu consulta…" rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="support-message-input" className="bg-[#0A0D14]" />
          <button onClick={send} data-testid="support-send-btn" className="px-4 py-2 rounded-lg bg-blue-500 hover:bg-blue-400 text-white text-sm">Enviar</button>
        </Card>
        <div className="space-y-3" data-testid="support-ticket-list">
          {tickets.length === 0 && <Card className="text-slate-500 text-sm border-dashed">Sin solicitudes.</Card>}
          {tickets.map((t) => (
            <Card key={t.id} data-testid={`ticket-${t.id}`}>
              <div className="flex justify-between gap-3"><h3 className="text-white font-medium">{t.subject}</h3><StatusBadge ok={t.status === "resuelto"}>{TICKET_LABEL[t.status]}</StatusBadge></div>
              <p className="text-sm text-slate-400 mt-2 whitespace-pre-wrap">{t.message}</p>
              {t.reply && <p className="text-sm text-cyan-200 mt-3 border-l-2 border-cyan-500/50 pl-3 whitespace-pre-wrap">{t.reply}</p>}
              <p className="text-xs text-slate-600 mt-3">{fmtDate(t.created_at)}</p>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
